module.exports = __webpack_public_path__ + "static/media/DownloadLogs.22d8d54b.svg";